define(['angular'], function(angular) {


    function UserBackendProvider() {
        let bdcUrl;

        /**
         * Set KYP url
         * @param {String} url
         */
        this.setBDCUrl = function setBDCUrl(url) {
            bdcUrl = url;
        };

        this.$get = [
            '$http',
            function($http) {
                let self = {};

                /**
                 * get users
                 * @return {Promise}
                 */
                self.getUsers = function getUsers() {
                    return $http.get(bdcUrl + 'users').then(function(res) {
                        return res.data;
                    });
                };

                self.getSectors = function getSectors() {
                    return $http.get(bdcUrl + 'user/sectors').then(function(res) {
                        return res.data;
                    });
                };

                self.updateSector = function updateSector(id, sector) {
                    return $http.post(bdcUrl + 'user/sector/' + id, sector).then(function(res) {
                        return res.data;
                    });
                };

                self.getUsersByRole = function getUsersByRole(role) {
                    return $http.get(bdcUrl + 'users/' + role).then(function(res) {
                        return res.data;
                    });
                };

                self.createOrUpdateUser = function(user) {
                    return $http.post(bdcUrl + 'user', user).then(function(res) {
                        return res.data;
                    });
                };

                self.logOutHelpline = function () {
                    return $http.get(bdcUrl + 'auth/helpline/signout').then(function (res){
                        console.log(res.data);
                        document.location.href = res.data;
                    });
                }

                return self;
            }
        ];
    }

    angular.module('app.bdc.common.userBackendProvider', []).provider('userBackend', UserBackendProvider);
});
